import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetInvoicingStatisticsController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetInvoicingStatisticsController.php
* @route '/api/analytics/invoicing/statistics'
*/
const GetInvoicingStatisticsController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetInvoicingStatisticsController.url(options),
    method: 'post',
})

GetInvoicingStatisticsController.definition = {
    methods: ["post"],
    url: '/api/analytics/invoicing/statistics',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetInvoicingStatisticsController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetInvoicingStatisticsController.php
* @route '/api/analytics/invoicing/statistics'
*/
GetInvoicingStatisticsController.url = (options?: RouteQueryOptions) => {
    return GetInvoicingStatisticsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetInvoicingStatisticsController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetInvoicingStatisticsController.php
* @route '/api/analytics/invoicing/statistics'
*/
GetInvoicingStatisticsController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetInvoicingStatisticsController.url(options),
    method: 'post',
})

export default GetInvoicingStatisticsController